import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import CustomTextField from "../../components/fields/CustomTextField";
import CheckboxGroup from "../../components/fields/CheckboxGroup";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import {   checkUserRole,fetchAllPlantation, fetchAllCountry,createNewPlantation,uploadgeom} from "../../actions";
import Snackbar from '@material-ui/core/Snackbar';
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar'; 
import PlantationsTable from '../../utils/MainTable/PlantationsTable';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils  from '@date-io/date-fns'; 
import {MuiPickersUtilsProvider,KeyboardDatePicker }from '@material-ui/pickers';

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}


const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});

class PlantationList extends React.Component {
    

    constructor(props, context) {
        super(props, context);
        this.state = {
            open: false,
            userRoles:{
                userRoles:[],
                error:null
            },
            isSwitchSnackbarOn: false,
            loading:false, 
            plantationname:'',
            result:[],
            plantationViewEdit:[],
            getCountry:{},
            country:[],
            newPlantationName:'',
            cid: -1,
            selectedCountry:-1,
            certdate: new Intl.DateTimeFormat('en-US').format(new Date()),
            pmtdate : new Intl.DateTimeFormat('en-US').format(new Date()),
            mill:'',
            site:'',
            pmttype:'',
            pmtnum:'',
            area:0.0,
            certnum:'',
            member_num:'',
            member_year:1900,
            state_name:'',
            province_name:'',
            upload:{},


        }; 
        this.props.checkUserRole();
    }
 
    componentDidMount(){ 
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today =yyyy + '-' +mm + '-' + dd ;
        var cid = this.getParameterByName('cid');
        this.setState({ loading: false,
            dateFrom: today,
            dateTo:today,
            result:[],
            cid: cid
        }); 
        this.props.fetchAllPlantation( cid); 
    }
  
    handleChange=(name)=>(event )=>{
        this.updateSnackbarStatusFalse();
        this.setState({[name]: event.target.value});
    }

    
    static getDerivedStateFromProps(props, state) {
        let update = {};
        if (props.result  !== state.result) {
            update.result =props.result;
            update.loading= false ;
        }

        
        
        if(props.upload !== state.upload){ 
            update.upload = props.upload;
            update.loading=false;
            update.isSnackbarError = props.upload.isSnackbarError;
            update.isSwitchSnackbarOn =props.upload.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.upload.ErrorMessage;
        }

        if(props.getCountry !== state.getCountry){ 
            update.getCountry = props.getCountry;
            update.loading=false;
            update.isSnackbarError = props.getCountry.isSnackbarError;
            update.isSwitchSnackbarOn =props.getCountry.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.getCountry.ErrorMessage; 
            var a = props.getCountry.results;
            a=a.sort();
            update.country = a; 
        }
          
        if(props.plantationViewEdit !== state.plantationViewEdit){ 
            update.plantationViewEdit = props.plantationViewEdit;
            update.loading=false;
            update.isSnackbarError = props.plantationViewEdit.isSnackbarError;
            update.isSwitchSnackbarOn =props.plantationViewEdit.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.plantationViewEdit.ErrorMessage;
        }
          
        if(props.userRoles.success !== null)
        if(!props.userRoles.success){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
        }
        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
        }

        return update; 
    }

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    
    getParameterByName = (name) => {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
    
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
    
    
    handleSearch = event => {  
        this.setState({ loading: true, });  
        this.updateSnackbarStatusFalse();   
       // this.setState({ searchVal: event.target.value })
       this.props.fetchAllPlantation(this.state.cid); 
    };


    
    handleChangeCountry=event=>{
        this.setState({selectedCountry: event.target.value});
    }
    handleEditedContent=(data)=>{
        console.log(data)
        this.setState({updatedData: data});
    }


    handleDateChange=(name)=>event =>{
        this.updateSnackbarStatusFalse();  
        console.log(event)
        this.setState({[name]: new Intl.DateTimeFormat('en-US').format(Date.parse(event)) ,
        contextChanged:true});
    }

    handleCreatePlantation=()=>{
        var newPlantation={
            newPlantationName:this.state.newPlantationName,
            cid: this.state.cid,
            country_id:this.state.selectedCountry,
            certdate: this.state.certdate,
            pmtdate : this.state.pmtdate,
            mill:this.state.mill,
            site:this.state.site,
            pmttype:this.state.pmttype,
            pmtnum:this.state.pmtnum,
            area:this.state.area,
            certnum:this.state.certnum,
            member_num:this.state.member_num,
            member_year:this.state.member_year,
            state_name:this.state.state_name,
            province_name:this.state.province_name
        }

        this.props.createNewPlantation(newPlantation);
    }
    render() {

        const { classes } = this.props;
        const { users, order, orderBy, selected, rowsPerPage, page, offset, isSwitchSnackbarOn, isSnackbarError,plantationViewEdit ,country} = this.state;
      
        return (
            <MainWrapper
                history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
            <Paper style={{marginTop:'10px',marginBottom:'10px'}}>
                    <Grid container style={{padding:'10px'}}>
                    <Grid container  >
                            <Grid item>
                            <EnhancedTableToolbar
                            tableName='Create New Plantation' numSelected={0}
                        />
                            </Grid>
                            
                            <Grid item>
                                
                            </Grid>
                        </Grid>
                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                New Plantation Name
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="newPlantationName"
                                        label="New Plantation Name"
                                        onChange={ this.handleChange('newPlantationName')}
                                    />
                            </Grid>
                        </Grid>
                         
                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Site
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="newsite"
                                        label="Site"
                                        onChange={ this.handleChange('newsite')}
                                    />
                            </Grid>
                        </Grid>
                         
                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Mill
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="mill"
                                        label="Mill"
                                        onChange={ this.handleChange('mill')}
                                    />
                            </Grid>
                        </Grid>
                          
                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Payment Type
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="pmttype"
                                        label="Payment Type"
                                        onChange={ this.handleChange('pmttype')}
                                    />
                            </Grid>
                        </Grid>
                        
                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Payment Date
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}} xl={6}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="dd/MMM/yyyy"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label="Payment Date"
                                    value={this.state.pmtdate}
                                    onChange={this.handleDateChange('pmtdate')}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    />
                                    </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Payment Num
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="pmtnum"
                                        label="Payment Num"
                                        onChange={ this.handleChange('pmtnum')}
                                    />
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Area
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="area"
                                        label="Area"
                                        onChange={ this.handleChange('area')}
                                    />
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Certificate Date
                            </Grid>
                            
                            
                            <Grid item style={{padding:'10px'}} xl={6}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="dd/MMM/yyyy"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label="Certificate Date"
                                    value={this.state.certdate}
                                    onChange={this.handleDateChange('certdate')}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    />
                                    </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Certificate Num
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="certnum"
                                        label="Certificate Num"
                                        onChange={ this.handleChange('certnum')}
                                    />
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                            Member Num
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="member_num"
                                        label="Member Num"
                                        onChange={ this.handleChange('member_num')}
                                    />
                            </Grid>
                        </Grid>
                        
                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                            Member Year
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="member_year"
                                        label="Member Year"
                                        onChange={ this.handleChange('member_year')}
                                    />
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                            State Name
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="state_name"
                                        label="State Name"
                                        onChange={ this.handleChange('state_name')}
                                    />
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                            Province Name
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                                <TextField
                                        id="province_name"
                                        label="Province Name"
                                        onChange={ this.handleChange('province_name')}
                                    />
                            </Grid>
                        </Grid>

                        <Grid container  style={{marginLeft:'50px'}}>
                            <Grid item xs={1}>
                                Country
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                               
                                <FormControl className={classes.formControl}>
                                    <InputLabel shrink htmlFor="country-label-placeholder">
                                    Country
                                    </InputLabel>
                                    <Select
                                    value={this.state.selectedCountry}
                                    onChange={this.handleChangeCountry}
                                    inputProps={{
                                        name: 'country',
                                        id: 'country-label-placeholder',
                                    }}
                                    name="country"
                                    className={classes.selectEmpty}
                                    >
                                        
                                    {
                                    country.map(ei=>  
                                        <MenuItem  value={''+ei.id} key={ei.id}>{ei.country_name} </MenuItem>  
                                    )}
                                    </Select>
                                    <FormHelperText>Country</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container style={{marginTop:'10px',marginLeft:'50px'}}>
                            <Grid item xs={1}>
                            
                            </Grid>
                            
                            <Grid item style={{padding:'10px'}}>
                            <Button  variant="contained"
                    color="primary" onClick={()=>this.handleCreatePlantation()}>Save</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper> 

                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='Search Plantations' 
                        numSelected={0}
                    />
                    <div className={classes.search} style={{padding:'10px', paddingLeft:'20px'}}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="plantationname"
                                label="Plantation Name"
                                defaultValue={this.state.plantationname}
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleChange('plantationname')}
                            />
                            </Grid>
                            <Grid item>
                                <Button  variant="outlined"
                                onClick={(e) => this.handleSearch(e) } >Search</Button>
                            </Grid>
                            
                        </Grid>
                    </div>
                    <div className={classes.tableWrapper}>
                    <Grid container >
                            <Grid item xs={12}>
                                <PlantationsTable 
                                    data={plantationViewEdit.results} 
                                    handleEditedContent={this.handleEditedContent}
                                    cid={this.state.cid}
                                    uploadgeom={this.props.uploadgeom}
                                />
                            </Grid> 
                            <Grid item xs={12}>
                                <Grid container justify='center' alignItems='center'>
                                    <Button
                                            className={classes.button}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            disabled={this.state.isSwitchSnackbarOn} 
                                        >
                                            Save Edited info
                                        </Button> 
                                   
                                </Grid>
                        
                            </Grid>
                        </Grid>
                    </div>
                    <NotificationSnackBar
                            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                            isSnackbarError={this.state.isSnackbarError}
                            snackbarErrorMessage={this.state.snackbarErrorMessage}
                    />
                </Paper> 
                {this.state.loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                        <div className="d-flex justify-content-center">
                            <CircularProgress color="primary" size={70} thickness={7} />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

PlantationList.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(styles)(PlantationList);

SignInWithStyles = reduxForm({ 
    form: "PlantationListForm"
})(SignInWithStyles);

const mapStateToProps = ({ getCountry, upload, plantationViewEdit,userRoles }) => { 
    return { 
        upload:upload,
        getCountry:getCountry,
        plantationViewEdit:plantationViewEdit,
        userRoles: userRoles, 
    };
};

export default connect(
    mapStateToProps,
    {  checkUserRole,fetchAllPlantation ,fetchAllCountry ,createNewPlantation,uploadgeom}
    
)(SignInWithStyles);




// WEBPACK FOOTER //
// ./src/components/tabs/PlantationList.js